import {Avatar, Button} from "antd";
import styled from "styled-components";

export const MapContainer = styled.div`
    width: 100%;
    height: 100% !important;
    min-height: 100%;
    overflow: auto;
    border: 1px solid white;
    border-radius: 4px;
    z-index: 1;
    position: relative;
    /*            ^^ */
    ${({mode}) =>
        mode == "fixed" &&
        `position:fixed;
        left: 105px;
        right:25px;
        bottom:40px;
        top:95px;
        width:inherit;
        height:inherit;`}
`;
export const MapTools = styled(Button)`
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 5;
    background: #fff;
    right: 10px;
    top: 10px;
    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
    border-radius: 2px;
    padding: 0;
    svg {
        width: 1.5em;
        height: 1.5em;
        margin: 5px;
    }
`;

export const Marker = styled(Avatar)`
    position: absolute;
    background-color: ${props => props.color};
    transform: translate(-50%, -50%);
    border: 1px solid #021529;
    box-sizing: content-box;
    color: #021529;
    z-index: ${props => (props.$hover ? 2 : 1)};
    font-size: 14px !important;
    border-radius: ${props => props.$hover && "4px"};
    width: ${props => props.$hover && "auto"} !important;
    &:after {
        content: ${props => props.$hover && `"${props.text}"`};
        margin-left: 5px;
    }
    padding: ${props => props.$hover && "5px"} !important;
    transition: border-radius 0.1s;
`;
